import fetchCurrencyExchangeRates from "@App/data/fetchCurrencyExchangeRates";

/**
 * CNY total for display on the China payment summary.
 * Uses Rails Utils.convert_amount via /api/v0/currency_exchange_rates?amount=...
 */
const fetchChinaPaymentAmount = async (
  amount: number | string,
  currency: string,
): Promise<number | null> => {
  const base = currency?.toLowerCase();
  if (!base || amount == null || amount === "") return null;

  const rateData = await fetchCurrencyExchangeRates({
    base,
    target: "cny",
    amount,
  });

  const convertedAmount = rateData?.converted_amount;
  if (convertedAmount == null) return null;

  const parsed = Number(convertedAmount);
  return Number.isFinite(parsed) ? parsed : null;
};

export default fetchChinaPaymentAmount;
